import { Component, OnInit, Input, Output, EventEmitter, TemplateRef, ViewChild, OnDestroy, OnChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { AssignmentFilterParam } from '../assignment-filter-param';
import { SharedService } from '../../../shared-components/shared.service';
import { AssignmentService } from '../assignment.service';
import { LoginService } from '../../../shared-modules/login/login.service';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { SchoolYearSettings } from '../../../shared-components/year/school-year-settings.model';

@AutoUnsubscribe()
@Component({
  selector: 'assignment-filter',
  templateUrl: './assignment-filter.component.html',
  styleUrls: ['./assignment-filter.component.css']
})
export class AssignmentFilterComponent implements OnInit, OnDestroy, OnChanges {

  filterParam: AssignmentFilterParam;
  @Output() filterChange = new EventEmitter<string>();
  @Output() filterClose = new EventEmitter();
  @Input() clearFilterEvent: EventEmitter<any>;
  @Input() ShowByClass: boolean;
  @Input() schoolYearSettings: SchoolYearSettings;

  @ViewChild('AssignmentFilterTemplate') assignmentFilterTemplate: TemplateRef<any>;
  previousFilterParam = new AssignmentFilterParam();
  showFilterSubscription: Subscription;
  courses: any = [];
  courseTerms: any = [];
  v10: boolean;
  showPercentage = true;

  constructor(
    private assignmentService: AssignmentService,
    private loginService: LoginService
  ) { }

  ngOnInit() {
    this.v10 = this.loginService.LoginSettings.V10;
    this.filterParam = this.assignmentService.filterParam;

    Object.assign(this.previousFilterParam, this.filterParam);
  }

  ngOnChanges() {
    if (this.v10 == false && this.schoolYearSettings != null && this.schoolYearSettings.HideS360AssignmentPercentageColumn) {
      this.showPercentage = false;
    }
    else {
      this.showPercentage = true;
    }
  }

  ngOnDestroy() {
  }

  filterChangeByModel() {
    this.assignmentService.filterParam = this.filterParam;
    this.filterChange.emit();
  }

  clearFilter() {
    this.filterParam = new AssignmentFilterParam();
    this.previousFilterParam = new AssignmentFilterParam();
    this.filterChangeByModel();
  }

  closeFilter() {
    this.filterChangeByModel();
    this.filterClose.emit();
  }

  loadCourseAndTerms() {
    this.courses = this.assignmentService.getCoursesFromUPComingAssignments();
    this.courseTerms = this.assignmentService.getTermsFromUPComingAssignments();
  }

}
